<template>
    <div class="text-wrap module-wrap" :id="target" v-if="has_data" :data-log-content-ev="item.stat_flag">
        <header class="info">
            <i class="ico icon-ic_text"></i>
            <div class="title">{{item.title}}</div>
        </header>
        <div class="brief">{{item.brief}}</div>
    </div>
</template>
<script>
import Util from '../_utils/util';
export default {
  props: {
      target: {
          default: '',
          type: String
      },
      data: {
          default : {},
          type: [Object, Array]
      },
      findex: {
          default: '',
          type: [String, Number]
      }
  },
  mounted(){
      this.$nextTick(() => {
          let textItem = document.getElementById(this.target);
          this.$emit('mounted', [ textItem ]);
      })
  },
  computed: {
      item(){
        let item = {};
        let subId = window.subData.id;
        let stat_flag = `m-${subId}_subtexts_${this.findex}`;
        if(this.data[0]){
            item = this.data[0];
            item.stat_flag = stat_flag;
        }
        return item;
      },
      has_data(){
          if(this.item.title && this.item.brief){
              return true;
          }else{
              return false;
          }
      }
      
  }
}
</script>
<style lang="less">
.text-wrap{
    min-height: 18px;
    padding: 8px 13px;
    .info{
        float: left;
        display: flex;
        margin-right: 6px;        
        .title{
            padding: 3px 6px;
            border-radius: 0 9px 9px 0;
            background-color: #e8f1ff;
            color: #6d98d4;
        }
        .ico{
            font-size: 18px;/*no*/
            color: #6d98d4;
            margin-right: -3px;
            z-index: 1;
        }
    }
    .brief{
        font-size: 15px;/*no*/
        line-height: 19px;
        color: #999;
    }
}
</style>




// WEBPACK FOOTER //
// src/components/VText.vue